module.exports = __webpack_public_path__ + "img/BGProjectDetail.0800e7c0.jpg";